import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileBottomNav from "./MobileBottomNav";

export default function SiteLayout({ children }: { children: ReactNode }) {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 ${isHome ? "" : "pt-16 md:pt-[72px]"} pb-16 md:pb-0`}>
        {children}
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}